import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../../molecules';
import {
  IconText,
  ImageContainer,
  Container,
} from './AccountFeatureIcons.styles';

export const AccountFeatureIcon = ({ text, icon, alt }) => {
  return (
    <Container>
      <ImageContainer>
        <ResponsiveImage src={icon} alt={alt} width={75} height={75} />
      </ImageContainer>
      <IconText>{text}</IconText>
    </Container>
  );
};
AccountFeatureIcon.displayName = 'AccountFeatureIcon';
AccountFeatureIcon.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};
